/* eslint @typescript-eslint/ban-ts-ignore: 0 */

import { MouseEvent } from 'react'

import { fromEvent, merge } from 'rxjs'
import { mergeMap, takeWhile, map } from 'rxjs/operators'
import { SeekEvent } from '../types'

const mouseDrag = (ele, parentEle = window) => {

  const gridGap = 5
  const move$ = fromEvent(document, 'mousemove')
  const down$ = fromEvent(ele, 'mousedown')
  const up$ = fromEvent(document, 'mouseup')

  const getPosition = (event: MouseEvent) => {

    // @ts-ignore
    const { clientWidth, offsetLeft } = event.target
    const newOffsetX = event.pageX - offsetLeft
    const positionNormalised = (newOffsetX - gridGap) / clientWidth

    return positionNormalised

  }

  const getType = (rawType: string) => rawType === 'mouseup' ? 'seekComplete' : 'seek'

  return down$.pipe(
    mergeMap(() =>
      merge(move$, up$).pipe(
        // @ts-ignore
        map((val: MouseEvent): SeekEvent => ({ type: getType(val.type), position: getPosition(val) })),
        takeWhile(result => result.type !== 'seekComplete', true)
      )
    )
  )

}

export default mouseDrag
